var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scroller_wrapper",style:(_vm.WrapperStyle),on:{"scroll":_vm.scroll}},[_c('div',{ref:"scroller",staticClass:"scroller",style:(_vm.Style),attrs:{"scrollLeft":_vm.value}})])}
var staticRenderFns = []

export { render, staticRenderFns }